import React, { ReactNode } from "react";

import Box from "themeComponents/Box";

/** Responsive width for a single filter control (dropdown, etc.). */
export const filterItemSx = {
  width: { xs: "100%", sm: "min(100%, 280px)", lg: 220 },
  minWidth: 0,
  flex: { xs: "1 1 100%", sm: "1 1 auto" },
  maxWidth: { xs: "100%", lg: 280 },
};

interface FilterBarProps {
  children: ReactNode;
}

export function FilterItem({ children }: { children: ReactNode }): React.JSX.Element {
  return (
    <Box
      sx={{
        ...filterItemSx,
        "& .MuiFormControl-root, & > div": { width: "100%" },
      }}
    >
      {children}
    </Box>
  );
}

export function FilterBar({ children }: FilterBarProps): React.JSX.Element {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      alignItems="stretch"
      gap={1.5}
      width="100%"
      sx={{ rowGap: 1.5, columnGap: 1.5 }}
    >
      {children}
    </Box>
  );
}

export default FilterBar;
